import BaseApiAction from '@Actions/base-api-action';

export default class LinkTeamToClub extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-linkTeamToClub',
      payload: {
        club_id: this._payload.club_id,
        team_id: this._payload.team_id,
      },
    });
  }
  onSuccess(data) {
    super.onSuccess(...arguments);
  }
}
